import React, { useState } from "react";
import { Card, Col, Row, Typography, Space, Form, Dropdown, Table, Button } from "antd";
import { ActionButton, AlertModal, ModuleTopHeading, MyInput } from "../../components";
import { DeleteOutlined, EditOutlined, FilterOutlined } from "@ant-design/icons";
import { actionsApi, ApiCalls, TableLoader } from "../../shared";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const AppTable = ({ userData }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const { data: dat, loading, filters, pagination } = useSelector((state) => state?.addEditBox);
  const [visiblemodal, setVisibleModal] = useState(false);
  const [dashname, setDashName] = useState();

  const items = [
    {
      label: <a href="#">{t("A-Z")}</a>,
      key: "0",
    },
    {
      label: <a href="#">{t("Z-A")}</a>,
      key: "1",
    },
    {
      label: <a href="#">{t("Registration date")}</a>,
      key: "2",
    },
  ];

  const call = (pageNo = 1, pageSize = 10) => {
    dispatch(actionsApi?.viewAllAndroidBoxes({ ...filters, pageNo, pageSize }));
  };

  const columns = [
    {
      title: <Text>{t("DEVICES NAME")}</Text>,
      dataIndex: "boxName",
      key: "boxName",
    },
    {
      title: <Text>{t("MAC ADDRESS")}</Text>,
      dataIndex: "macAddress",
      key: "macAddress",
    },
    {
      title: <Text>{t("MASTER VENDOR NAME")}</Text>,
      dataIndex:
        userData && (userData.role === "masterAdmin"
          ? "vendorName"
          : userData.role === "masterVendor"
          ? "customerName"
          : "addedByName"),
      key:
        userData && (userData.role === "masterAdmin"
          ? "vendorName"
          : userData.role === "masterVendor"
          ? "customerName"
          : "addedByName"),
    },
    {
      title: <Text>{t("TIME STAMP")}</Text>,
      dataIndex: "dateTime",
      key: "dateTime",
    },
  ];

  const removeRow = async (ID) => {
    const result = await ApiCalls?.AddEditBoxApi?.DeleteAndroidApi(ID);
    if (result) {
      dispatch(actionsApi?.getStatistics());
      return 1;
    }
    return 0;
  };

  return (
    <div>
      <Card className="radius-12 border0">
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <ModuleTopHeading name={t("Latest registered devices")} />
          </Col>
          <Col span={24}>
            <Form form={form} layout="vertical">
              <Space className="align-center mbl-wrap">
                <MyInput
                  name="vendorName"
                  label={t("Vendor Name")}
                  placeholder={t("e.g John Doe")}
                  value={form.getFieldValue("vendorName") || ""}
                  style={{ width: "220px" }}
                />
                <Dropdown
                  menu={{
                    items,
                  }}
                  trigger={["click"]}
                  arrow
                  icon={<FilterOutlined />}
                >
                  <Button className="margin-top" icon={<FilterOutlined />}>
                    {t("Filter")}
                  </Button>
                </Dropdown>
              </Space>
            </Form>
          </Col>
          <Col span={24}>
            <Table
              size="large"
              columns={columns}
              dataSource={dat || []}
              style={{
                border: "1.81193px solid #ECEEF7",
                borderRadius: 20,
                padding: "9px 9px 0 9px",
              }}
              scroll={{ x: 1000 }}
              pagination={{
                hideOnSinglePage: true,
                total: pagination?.totalRecords,
                pageSize: pagination?.pageSize,
                defaultPageSize: pagination?.pageSize,
                current: pagination?.pageNo,
                size: "default",
                pageSizeOptions: ["10", "20", "50", "100"],
                onChange: (pageNo, pageSize) => call(pageNo, pageSize),
                showTotal: (total) => <Button>{t("Total")}: {total}</Button>,
              }}
              loading={{
                ...TableLoader,
                spinning: loading,
              }}
            />
          </Col>
        </Row>
      </Card>

      <AlertModal
        visible={visiblemodal}
        row={dashname}
        removeRow={removeRow}
        endCall={call}
        onClose={() => {
          setVisibleModal(false);
          setDashName(null);
        }}
      />
    </div>
  );
};

export { AppTable };
